import { render, staticRenderFns } from "./ApplicationDetailsForChange.vue?vue&type=template&id=052e3327&"
import script from "./ApplicationDetailsForChange.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsForChange.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDetailsForChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports